// extracted by mini-css-extract-plugin
module.exports = {"override":"styles_override__1yvVe"};